import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetail } from "@/components/site/ServiceDetail";
import deepAssetUrl from "@/assets/svc-deep-new.webp";
const deepAsset = { url: deepAssetUrl };

export const Route = createFileRoute("/services/deep")({
  head: () => ({
    meta: [
      { title: "Deep Cleaning in Tidworth, Andover & Salisbury | IZHUB" },
      { name: "description", content: "Professional deep cleaning across Tidworth, Andover and Salisbury. Top-to-bottom cleans from £25/hour — kitchens degreased, bathrooms descaled, every detail covered." },
      { property: "og:title", content: "Deep Cleaning | IZHUB Cleaning Services" },
      { property: "og:description", content: "A thorough top-to-bottom deep clean for homes that need more than a regular tidy — from £25/hour across Salisbury Plain." },
      { property: "og:url", content: "https://izhubcleaning.uk/services/deep" },
    ],
    links: [{ rel: "canonical", href: "https://izhubcleaning.uk/services/deep" }],
  }),
  component: DeepPage,
});

function DeepPage() {
  return (
    <ServiceDetail
      data={{
        title: "Deep Cleaning",
        heroTitle: <>A deep clean that reaches the places <span className="rainbow-text">regular cleans miss</span>.</>,
        intro: "A thorough top-to-bottom clean for homes that need a proper reset — from £25/hour across Tidworth, Andover and Salisbury.",
        image: deepAsset.url,
        imageAlt: "Professional deep cleaning of a kitchen",
        forWho: "Homes that haven't been deep-cleaned recently, spring cleans, pre-viewing preparation.",
        quoteService: "deep",
        includes: [
          "Kitchen degrease including hob, oven exterior and extractor",
          "Bathroom limescale removal and grout attention",
          "Skirting boards, door frames, light switches and radiators",
          "Detailed surface, edge and often-missed areas",
          "Inside windows and internal glass on request",
          "Optional oven interior and carpet add-ons",
        ],
        paragraphs: [
          "A deep clean goes far beyond a regular tidy. We work methodically through your home, tackling built-up grease in the kitchen, limescale in the bathroom, and the skirting boards, door frames and light fittings that quietly collect grime over months.",
          "Deep cleans are priced at £25/hour, and most homes take between 3 and 6 hours depending on size and condition. Our instant quote calculator gives you a clear estimate before you book — no surprises.",
          "It's the perfect seasonal reset, pre-viewing preparation, or first visit before starting a regular cleaning schedule. We bring all products and equipment, and every clean is carried out by vetted, insured professionals.",
        ],
      }}
    />
  );
}
